import React from "react";
import {Button} from "react-bootstrap";
import {useHistory} from 'react-router-dom'
import ApiRest from "../../../../service/ApiRest";

interface Props {
    id: number
}

export default function DeleteButton(props: Props) {
    const history = useHistory();
    const {id} = props;

    const doDelete = () => {
        ApiRest.deleteElement('invoice', id).then(res => {
            history.push('/invoices');
        });
    }

    return (
        <Button variant={"danger"} onClick={doDelete}>Ištrinti</Button>
    )
}